module.exports = __webpack_public_path__ + "static/media/ic_dashboard_gold.99191632.svg";